import React from 'react';
import { EmptySelectionPlaceholder as EmptySelectionPlaceholderComponent } from '../../../../components';
import { useAppContext } from '../../../../context/AppState.jsx';
import { getAppSelectedLanguage } from '../../../../actions';
import getTranslatedString from '../../../../utils/getTranslatedString';

// String UIDs for placeholder text - update these once UIDs are identified
const TITLE_STRING_UID = 504; // UID for 'The Most Comprehensive dataset of African Governance.'
const DESCRIPTION_STRING_UID = 505; // UID for 'Choose a measure, location and view from the options above to get started.'

export default function EmptySelectionPlaceholder() {
	const [state] = useAppContext();
	const lang = getAppSelectedLanguage();

	if (!state?.translatedText) {
		return null;
	}

	const title = [getTranslatedString(state.translatedText, TITLE_STRING_UID, lang)];
	const description = getTranslatedString(state.translatedText, DESCRIPTION_STRING_UID, lang);

	return <EmptySelectionPlaceholderComponent title={title} description={description} />;
}
